import React from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiPlay, FiCalendar, FiCheckCircle} = FiIcons;

const HeroSection = () => {
  const badges = [
    "שקיפות מלאה",
    "עונה בשפת המותג", 
    "הצפנה ותיעוד מלא",
    "דיסקליימר \"אין ייעוץ משפטי\" כברירת מחדל"
  ];
  
  const botleyImageUrl = "https://i.imgur.com/Z4ArBeZ.jpg";
  const logoUrl = "https://i.imgur.com/0eWlYXE.png";

  return (
    <section className="hero-section hero-gradient text-white relative overflow-hidden">
      <div className="container relative z-10 min-h-[80vh] flex items-center py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center w-full">
          
          {/* Text Content - Right side in RTL */}
          <motion.div 
            className="hero-text"
            initial={{opacity: 0, x: 50}} 
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.2}}
          >
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={logoUrl} 
                alt="Botley Logo" 
                className="h-12 w-auto"
              />
              <span className="text-2xl font-bold">Botley</span>
            </div>
            
            <h1 className="text-4xl lg:text-5xl font-extrabold leading-tight mb-6">
              משרד עורכי דין שתמיד עונה ללקוח בזמן – מרוויח לקוח מרוצה.
            </h1>
            
            <p className="text-xl lg:text-2xl mb-8 text-indigo-100/90 leading-relaxed">
              Botley הוא סוכן AI מייצג-מותג שעונה בשם המשרד 24/7 ביותר מ־100 שפות, מעלה את ערך הלידים ב־30% באמצעות טפסי דיאלוג חכמים, ושומר על שפה משפטית מאושרת מראש.
            </p>
            
            <div className="cta-buttons flex flex-col sm:flex-row gap-4 mb-12">
               <a 
                href="https://link.botley.co.il/farbman-law-video"
                className="btn btn-primary text-lg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SafeIcon icon={FiPlay} />
                צפה בהדגמה חיה
              </a>
              <a 
                href="https://link.botley.co.il/botley_demo_website"
                className="btn btn-secondary text-lg"
                target="_blank"
                rel="noopener noreferrer"
              >
                <SafeIcon icon={FiCalendar} />
                קבע הדגמה אישית
              </a>
            </div>
            
            <div className="badges grid grid-cols-1 sm:grid-cols-2 gap-4">
              {badges.map((badge, index) => (
                <motion.div
                  key={index}
                  className="badge flex items-center gap-3 text-sm font-medium"
                  initial={{opacity: 0, y: 20}}
                  animate={{opacity: 1, y: 0}}
                  transition={{delay: 0.4 + index * 0.1}}
                >
                  <SafeIcon icon={FiCheckCircle} className="text-green-300 flex-shrink-0" />
                  <span>{badge}</span>
                </motion.div>
              ))}
            </div>
          </motion.div>
          
          {/* Botley Legal AI Image - Left side in RTL */}
          <motion.div 
            className="hero-image relative flex justify-center items-center"
            initial={{opacity: 0, x: -50}} 
            animate={{opacity: 1, x: 0}}
            transition={{duration: 0.8, delay: 0.4}}
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white/10 backdrop-blur-sm bg-white/10 p-1">
              <img 
                src={botleyImageUrl}
                alt="Botley Legal AI"
                className="w-full h-auto max-w-lg rounded-xl"
                style={{maxHeight: '500px', objectFit: 'contain'}}
              />
            </div>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;